<template>
  <div class="one_box">
      <div class="one_main">
          <div class="one_m_tit1">{{$t('main.text22')}}</div>
          <div class="one_m_tit2">{{$t('main.text82')}}</div>
          <div class="two_form_box">
            <el-form label-position="top" :model="form_data">
              <el-form-item :label="$t('main.text142')">
                <el-input :disabled="input_dab" v-model="form_data.company_name"></el-input>
              </el-form-item>
              <el-form-item :label="$t('main.text143')">
                <el-input :disabled="input_dab" v-model="form_data.registered_address"></el-input>
              </el-form-item>
              <el-form-item :label="$t('main.text144')">
                <el-select filterable :disabled="input_dab" v-model="form_data.country" :placeholder="$t('main.text135')">
                  <el-option v-for="(item,index) in country" :key="index" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('main.text145')">
                <el-input :disabled="input_dab" v-model="form_data.mailing_address"></el-input>
              </el-form-item>

              <el-form-item :label="$t('main.text146')">
                <div class="code_w">
                  <div class="code_w3">
                    <el-select filterable :disabled="input_dab" v-model="form_data.telephone_number_code" :placeholder="$t('main.text200')">
                      <el-option
                        v-for="item in code_json"
                        :key="item"
                        :label="findKey(code_json, item)"
                        :value="findKey(code_json, item)">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="reg_code_box">
                    <el-input class="code_w2" :disabled="input_dab" v-model="form_data.telephone_number"></el-input>
                  </div>
                </div>
              </el-form-item>

              <el-form-item :label="$t('main.text147')">
                <el-input :disabled="input_dab" v-model="form_data.company_website"></el-input>
              </el-form-item>
              <el-form-item :label="$t('main.text35')">
                <el-input :disabled="input_dab" v-model="form_data.email_address"></el-input>
              </el-form-item>

              <el-form-item :label="$t('main.text148')">
                <el-input :disabled="input_dab" v-model="form_data.registration_number"></el-input>
                <!-- <div class="code_w">
                  <div class="code_w3">
                    <el-select filterable v-model="form_data.registration_number_code" :placeholder="$t('main.text200')">
                      <el-option
                        v-for="item in code_json"
                        :key="item"
                        :label="findKey(code_json, item)"
                        :value="findKey(code_json, item)">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="reg_code_box">
                    <el-input class="code_w2" :disabled="input_dab" v-model="form_data.registration_number"></el-input>
                  </div>
                </div> -->
              </el-form-item>

              <el-form-item :label="$t('main.text149')">
                <el-select filterable :disabled="input_dab" v-model="form_data.country_registration" :placeholder="$t('main.text135')">
                  <el-option v-for="(item,index) in country" :key="index" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('main.text150')">
                <!-- <el-input :disabled="input_dab" v-model="form_data.date_registration"></el-input> -->
                <!-- :format="v_lan=='en'?'dd/MM/yyyy':'yyyy/MM/dd' " -->
                <el-date-picker
                  class="time_box"
                  :editable="false"
                  :popper-class="lan=='en'?'zdy_picker_en':'' "
                  :disabled="input_dab"
                  v-model="form_data.date_registration"
                  type="date"
                  :format="v_lan=='en'?'dd/MM/yyyy':'yyyy/MM/dd' "
                  value-format="dd-MM-yyyy"
                  :placeholder="$t('main.text242')">
                </el-date-picker>
                <!-- value-format="yyyy-MM-dd" -->

              </el-form-item>
              <el-form-item :label="$t('main.text178')">
                <el-input :disabled="input_dab" v-model="form_data.no_of_years"></el-input>
              </el-form-item>
              <el-form-item :label="$t('main.text151')">
                <el-input :disabled="input_dab" v-model="form_data.nature_of_business"></el-input>
              </el-form-item>
              <el-form-item :label="$t('main.text152')">
                <el-select filterable :disabled="input_dab" v-model="form_data.entity_type" :placeholder="$t('main.text135')">
                  <el-option :label="$t('main.text153')" :value="$t('main.text153')"></el-option>
                  <el-option :label="$t('main.text154')" :value="$t('main.text154')"></el-option>
                  <el-option :label="$t('main.text155')" :value="$t('main.text155')"></el-option>
                  <el-option :label="$t('main.text156')" :value="$t('main.text156')"></el-option>
                  <el-option :label="$t('main.text157')" :value="$t('main.text157')"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('main.text158')">
                <el-input :disabled="input_dab" v-model="form_data.countries_business"></el-input>
              </el-form-item>
              <el-form-item :label="$t('main.text159')">
                <el-input :disabled="input_dab" v-model="form_data.no_of_employees"></el-input>
              </el-form-item>
              <el-form-item :label="$t('main.text160')">
                <el-input :disabled="input_dab" v-model="form_data.approximate_no_of_clients"></el-input>
              </el-form-item>
              <el-form-item :label="$t('main.text161')">
                <div class="num_lift"><span>1.</span><el-input :disabled="input_dab" v-model="form_data.top_5_country[0]"></el-input></div>
                <div class="num_lift"><span>2.</span><el-input :disabled="input_dab" v-model="form_data.top_5_country[1]"></el-input></div>
                <div class="num_lift"><span>3.</span><el-input :disabled="input_dab" v-model="form_data.top_5_country[2]"></el-input></div>
                <div class="num_lift"><span>4.</span><el-input :disabled="input_dab" v-model="form_data.top_5_country[3]"></el-input></div>
                <div class="num_lift"><span>5.</span><el-input :disabled="input_dab" v-model="form_data.top_5_country[4]"></el-input></div>
              </el-form-item>
              <el-form-item :label="$t('main.text162')">
                <el-input :disabled="input_dab" v-model="form_data.annual_turnover"></el-input>
              </el-form-item>
              <el-form-item>
                <span slot="label">
                  <div>{{$t('main.text126')}}</div>
                  <div>{{$t('main.text163')}}</div>
                </span>
                <el-input :disabled="input_dab" v-model="form_data.purpose_of_transaction"></el-input>
              </el-form-item>
              <el-form-item>
                <span slot="label">
                  <div>{{$t('main.text164')}}</div>
                  <div>{{$t('main.text163')}}</div>
                </span>
                <el-input :disabled="input_dab" v-model="form_data.source_of_wealth"></el-input>
              </el-form-item>
              <el-form-item :label="$t('main.text165')">
                <div class="num_lift"><span>1.</span><el-input :disabled="input_dab" v-model="form_data.top_3_currencies[0]"></el-input></div>
                <div class="num_lift"><span>2.</span><el-input :disabled="input_dab" v-model="form_data.top_3_currencies[1]"></el-input></div>
                <div class="num_lift"><span>3.</span><el-input :disabled="input_dab" v-model="form_data.top_3_currencies[2]"></el-input></div>
              </el-form-item>
              <el-form-item :label="$t('main.text166')">
                <el-select filterable :disabled="input_dab" v-model="form_data.expected_monthly_volume" :placeholder="$t('main.text135')">
                  <el-option :label="$t('main.text167')" :value="$t('main.text167')"></el-option>
                  <el-option :label="$t('main.text168')" :value="$t('main.text168')"></el-option>
                  <el-option :label="$t('main.text169')" :value="$t('main.text169')"></el-option>
                  <el-option :label="$t('main.text170')" :value="$t('main.text170')"></el-option>
                  <el-option :label="$t('main.text171')" :value="$t('main.text171')"></el-option>
                  <el-option :label="$t('main.text172')" :value="$t('main.text172')"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('main.text173')">
                <el-select filterable :disabled="input_dab" v-model="form_data.expected_monthly_frequency" :placeholder="$t('main.text135')">
                  <el-option :label="$t('main.text174')" :value="$t('main.text174')"></el-option>
                  <el-option :label="$t('main.text175')" :value="$t('main.text175')"></el-option>
                  <el-option :label="$t('main.text176')" :value="$t('main.text176')"></el-option>
                  <el-option :label="$t('main.text177')" :value="$t('main.text177')"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button :disabled="input_dab" class="Submit_btn" @click="submit_all">{{$t('main.text104')}}</el-button>
              </el-form-item>

            </el-form>
          </div>
          
      </div>
  </div>
</template>

<script>
import {kyc_company,getKycInfo} from '@/api/api';
// import {getKycInfo} from '@/api/api';
export default {
    data() {
        return {
          //Company information
          lan:localStorage.getItem("language"),
          form_data:{
            "company_name": "",
            "registered_address": "",
            "country": "",
            "mailing_address": "",
            "telephone_number": "",
            "company_website": "",
            "email_address": "",
            "registration_number": "",
            "country_registration": "",
            "date_registration":'',
            "no_of_years": "",
            "nature_of_business": "",
            "entity_type": "",
            "countries_business": "",
            "no_of_employees": "",
            "approximate_no_of_clients": "",
            "top_5_country": ['','','','',''],
            "annual_turnover": "",
            "purpose_of_transaction": "",
            "source_of_wealth": "",
            "top_3_currencies": ['','',''],
            "expected_monthly_volume": "",
            "expected_monthly_frequency": "",
            telephone_number_code:'',
            // registration_number_code:''
          },
          data_api:'',
          data_all:null,//是否全部填写数据
          input_dab:false,
          country:'',
          code_json:'',

          api_old_data:'',//老数据

        }
    },
    created() {
      if(this.v_lan=='ch'){
        this.country=require("@/assets/country_en/country_ch.json");
        this.code_json=require("@/assets/phone_code/num_area_ch.json");
      }else{
        this.country=require("@/assets/country_en/country.json");
        this.code_json=require("@/assets/phone_code/num_area_en.json");
      }
    },
    mounted() {
      this.get_kyc();
      this.bus.$on('router_4_child',(v)=>{
        if(v==2){
          // 重新触发 保存操作
          this.submit_all();
        }
      })
    },
    destroyed(){
      this.bus.$off('router_4_child')
    },
    watch:{
      form_data:{ //监听的对象
        deep:true, //深度监听设置为 true
        handler:function(newV,oldV){
          newV;oldV;
          this.old_data_new_data();
        }
      }
    },
    methods: {
      //创建一个方法，返回value值对应的key
      findKey(obj, value, compare = (a, b) => a === b) {
        return Object.keys(obj).find((k) => compare(obj[k], value));
      },
      submit_all(){

        let flag=null;
        if(this.form_data['top_5_country'].every(item=>item=='')&&
            this.form_data['top_3_currencies'].every(item=>item=='')
        ){
          for (const key in this.form_data) {
            if(this.form_data[key]==''||(typeof this.form_data[key]=='object'&&this.form_data[key].every(item=>item==''))){
              flag=true;
            }else{
              flag=false;
              break;
            }
          }
        }else{
          flag=false;
          
        }
        
        if (flag) {
          
            this.message.ismessage('error',this.$t('main.text107'));
            this.$store.state.login.router_true=false;
            return false;
        }


        if(this.form_data['top_5_country'].length==5&&this.form_data['top_5_country'].some(item=>item!='')&&
          this.form_data['top_3_currencies'].length==3&&this.form_data['top_3_currencies'].some(item=>item!='')){
          for (const key in this.form_data) {
            if(this.form_data[key]==''||this.form_data[key]==null){
              this.data_all=false;
              break;
            }else{
              this.data_all=true;
            }
          }
        }else{
          this.data_all=false;
        }
        

        // company_status	Number	0信息不完整 1信息完整
        // company_info	Object

        kyc_company({
          company_status:this.data_all?1:0,
          company_info:this.form_data
        }).then(res=>{
          if(res.data.code==200){
            
            this.message.ismessage('success',this.$t('main.text108'));
            this.get_kyc();
            
            setTimeout(() => {
              this.bus.$emit('info_4_all');
            }, 100);
          }else{
            
            this.message.ismessage('error',res.data.msg);
            this.$store.state.login.data_no_router=false;
          }
        })

      },
      get_kyc(){
        getKycInfo().then(res=>{
          if(res.data.code==200){
              // "company_info": company_information 详情
              // "company_status": 0 Company information状态 0信息不完整 1信息完整,
              if(res.data.data.company_info&&res.data.data.company_info!=''){
                let data1=JSON.parse(res.data.data.company_info);
                


                if(!data1.telephone_number){
                  data1.telephone_number=localStorage.getItem('phone_num');
                }
                if(!data1.telephone_number_code){
                  data1.telephone_number_code=localStorage.getItem('phone_cc');
                }
                // if(!data1.registration_number){
                //   data1.registration_number=localStorage.getItem('feb_phone_num');
                // }

                // 删除老数据残留
                if('registration_number_code' in data1){
                  this.$delete(data1,'registration_number_code')
                  this.form_data=data1;
                  this.api_old_data=JSON.parse(JSON.stringify(data1));//老数据
                  
                }else{
                  this.form_data=data1;
                  this.api_old_data=JSON.parse(JSON.stringify(data1));//老数据
                  
                }

                

              }else{
                
                let data1=JSON.parse(JSON.stringify(this.form_data));
                if(!data1.telephone_number){
                  data1.telephone_number=localStorage.getItem('phone_num');
                }
                if(!data1.telephone_number_code){
                  data1.telephone_number_code=localStorage.getItem('phone_cc');
                }
                this.form_data=data1;
                this.api_old_data=JSON.parse(JSON.stringify(data1));

              }
              // status 2 待审核   3审核中  4审核通过  5审核失败
              if(
                  res.data.data.status==2||
                  res.data.data.status==3||
                  res.data.data.status==4||
                  res.data.data.status==5
                  ){
                      this.input_dab=true;
              }else{
                  this.input_dab=false;
              }

              
          }else{
            
            this.message.ismessage('error',res.data.msg);
          }
        })
      },
      old_data_new_data(){
        if(this.api_old_data&&this.form_data){
          let data_true=(JSON.stringify(this.api_old_data) == JSON.stringify(this.form_data));
         
          this.$store.state.login.router_true=data_true;
        }else if(this.api_old_data==''&&this.form_data){
          console.log(2);
        }
      },


    },
}
</script>

<style scoped>
.one_box{
    flex: 1;
    background: #04182A;
    border-radius: 16px;
    box-sizing: border-box;
    padding: 60px 0;
}
.one_main{
    width: 420px;
    margin: auto;
}
.one_m_tit1{
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 26px;
    margin-bottom: 8px;
}
.one_m_tit2{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    opacity: 0.8;
    margin-bottom: 40px;
}
.one_m_tit3{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    opacity: 0.8;
    margin-bottom: 8px;
}
.Submit_btn,
.Submit_btn:hover{
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    border-color: #F1C788;
    width: 100%;
    color: #04182A;
    margin-bottom: 30px;
}

.two_form_box >>> .el-form--label-top .el-form-item__label{
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.two_form_box >>> .el-input__inner{
  background: #223C58;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 4px;
  color: #fff;
}
.two_form_box .el-select {
  width: 100%;
}
.num_lift{
  position: relative;
  margin-bottom: 8px;
}
.el-form-item .num_lift:last-child{
  margin-bottom: 0;
}
.num_lift span{
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
}
.num_lift >>> .el-input__inner{
  text-indent: 1em;
}
/* 滚动条 */
.one_box {
  overflow: auto;
  height: calc(100vh - 120px);
}
.one_box::-webkit-scrollbar {
  width: 5px;
}
.one_box::-webkit-scrollbar-thumb {
  border-radius: 5px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  background: #F1C788;
}
/* --over-- */

/* 手机国家码 */
.code_w{
  display: flex;
}
.code_w2{
  /* width: 68%; */
}
.code_w3{
  margin-right: 16px;
  /* flex: 1; */
}
.code_w3 span{
  background: #000;
}
.reg_code_box{
  position: relative;
  width: 80%;
}
/* over */
.time_box{
  width: 100%;
}
</style>

<style scoped>
@media screen and (max-width: 850px) {
    .one_main {
        margin: auto;
        width: 100%;
    }


}
</style>